import 'css-chunk:src/app/components/FilterList/fieldTypes/BooleanEqual.scss';export default {
  "BooleanEqual": "_BooleanEqual_1ti56_1"
};